import { create } from 'zustand';

import { snackbarHorizontal, snackbarType, snackbarVertical } from '@/lib/enums';

export type SnackbarType = 'error' | 'success';
export type SnackbarVertical = 'top' | 'bottom';
export type SnackbarHorizontal = 'left' | 'center' | 'right';

export interface SnackbarOptions {
  type?: SnackbarType;
  vertical?: SnackbarVertical;
  horizontal?: SnackbarHorizontal;
  persist?: boolean; // If true, snackbar will not auto-hide and must be closed manually
}

export interface SnackbarStore {
  open: boolean;
  message: string;
  type: SnackbarType;
  vertical: SnackbarVertical;
  horizontal: SnackbarHorizontal;
  persist: boolean; // If true, snackbar will not auto-hide
  openSnackbar: () => void;
  closeSnackbar: () => void;
  setSnackbarMessage: (message: string, options?: SnackbarOptions) => void;
}

export const useSnackbar = create<SnackbarStore>((set) => ({
  open: false,
  message: '',
  type: snackbarType.SUCCESS,
  vertical: snackbarVertical.TOP,
  horizontal: snackbarHorizontal.CENTER,
  persist: false,
  openSnackbar: () => set({ open: true }),
  closeSnackbar: () => set({ open: false }),
  setSnackbarMessage: (message: string, options?: SnackbarOptions) =>
    set({
      message: message,
      open: true,
      type: options?.type ?? snackbarType.SUCCESS,
      vertical: options?.vertical ?? snackbarVertical.TOP,
      horizontal: options?.horizontal ?? snackbarHorizontal.CENTER,
      persist: options?.persist ?? false,
    }),
}));
